import React, { useState, useRef } from "react";
import "./Question.css";
import Option from "./Option/Option";

interface QuestionProps {
  questionTitle: string;
  options: OptionsProps[];
  resolveQuestion: () => any;
  getNextOption: () => any;
  goToGameOver: () => void;
  increaseScore: () => void;
}

interface OptionsProps {
  name: string;
  description: string;
  hint: string;
  colour: string;
  icon: string;
}

// Used to decide which Option will be removed after a successful answer.
let rotateOptionId = -1;

const Question: React.FC<QuestionProps> = ({
  questionTitle,
  options,
  resolveQuestion,
  getNextOption,
  goToGameOver,
  increaseScore,
}) => {
  const animating = useRef(false);

  const [optionStates, setOptionStates] = useState<number[]>([0, 0]);
  const [isCorrect, setIsCorrect] = useState<boolean[]>([false, false]);
  const [showHint, setShowHint] = useState<boolean[]>([true, false]);

  const animateAndReemplaceOptions = (selectedAnswer: number) => {
    if (animating.current) {
      return;
    }
    animating.current = true;
    rotateOptionId = (rotateOptionId + 1) % options.length;

    const correctOption = resolveQuestion();
    const newIsCorrect = [...isCorrect];

    let correctAnswer = 0;
    for (let i = 0; i < options.length; i++) {
      const option = options[i];
      newIsCorrect[i] = false;
      if (option.name === correctOption.name) {
        newIsCorrect[i] = true;
        correctAnswer = i;
      }
    }

    setIsCorrect(newIsCorrect);

    const newStates = [...optionStates];
    // Results
    newStates[selectedAnswer] = 1;
    setOptionStates(newStates);
    setShowHint([true, true]);

    setTimeout(() => {
      if (correctAnswer !== selectedAnswer) {
        goToGameOver();
        return;
      }
      increaseScore();
    }, 1950);

    // Clean up
    setTimeout(() => {
      const newStates = [...optionStates];
      newStates[selectedAnswer] = 0;
      setOptionStates(newStates);
    }, 2000);

    // Hide the answer to rotate
    setTimeout(() => {
      const newStates = [...optionStates];
      newStates[rotateOptionId] = 2;
      setOptionStates(newStates);
    }, 2500);

    // Reemplace
    setTimeout(() => {
      let nextOption = getNextOption();
      options[rotateOptionId] = nextOption;
      let newShowHints = [true, true]; // Do not show hint on the new option
      newShowHints[rotateOptionId] = false;
      setShowHint(newShowHints);
    }, 3000);

    // Come back
    setTimeout(() => {
      const newStates = [...optionStates];
      newStates[rotateOptionId] = 3;
      setOptionStates(newStates);
    }, 3100);

    // Clean up
    setTimeout(() => {
      setOptionStates([0, 0]);
      setIsCorrect([false, false]);
      animating.current = false;
    }, 4000);
  };

  //       
  return (
    <div className="question-container">
      <div className="question-title-card card"><h1 className="question-title">{questionTitle}</h1></div>
      <div className="options">
        <Option
          id={0}
          option={options[0]}
          handleAnswer={animateAndReemplaceOptions}
          isCorrect={isCorrect[0]}
          state={optionStates[0]}
          showHint={showHint[0]}
        />
        <Option
          id={1}
          option={options[1]}
          handleAnswer={animateAndReemplaceOptions}
          isCorrect={isCorrect[1]}
          state={optionStates[1]}
          showHint={showHint[1]}
        />
      </div>
    </div>
  );
};

export default Question;
